import { render, staticRenderFns } from "./TotalPointCard.vue?vue&type=template&id=0b8edc83&scoped=true&"
import script from "./TotalPointCard.vue?vue&type=script&lang=js&"
export * from "./TotalPointCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8edc83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
